import React from 'react';
import notFound from './../../src/images/img-error@2x.png';

export class NotFound extends React.Component {
  render() {
    return (
      <article className='error'>
        <div className='error__body'>
          <div className='error__title'>指定されたページは存在しません。</div>

          <div className='error__image'>
            <img src={notFound} alt='' />
          </div>

          <p className='error__message'>
            大変申し訳ございません。指定されたページは
            削除されたかアドレスが間違っている可能性があります。
          </p>

          <div className='error__button'>
            <a
              href='#'
              className='btn--sub'
              style={{ pointerEvents: 'all' }}
              onClick={() => { window.history.back(); }}
            >
              戻る
            </a>
          </div>
        </div>
      </article>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/NotFound.jsx